var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCategories(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.48094 17.5225C9.11983 17.8034 8.61416 17.8034 8.25305 17.5225L0.99454 11.877C0.490112 11.4846 0.490112 10.7222 0.99454 10.3299C1.34836 10.0547 1.8438 10.0547 2.19767 10.3298L8.24323 15.0301C8.60434 15.3108 9.10991 15.3108 9.47096 15.03L15.5217 10.3238C15.8783 10.0465 16.3777 10.0467 16.734 10.3243C17.2414 10.7196 17.2411 11.4868 16.7334 11.8817L9.48094 17.5225ZM9.48089 13.3152C9.11983 13.5963 8.61403 13.5964 8.25279 13.3156L1.60591 8.14778L1.01332 7.68607C0.499194 7.28549 0.499524 6.50803 1.01399 6.10789L8.25305 0.47751C8.61416 0.196646 9.11983 0.196646 9.48094 0.477509L16.7169 6.10547C17.2323 6.50637 17.2315 7.28567 16.7152 7.68548L16.1182 8.14778L9.48089 13.3152Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCategories);
export default __webpack_public_path__ + "static/media/categories.d9406982bd00bf46d8708753c353ab3a.svg";
export { ForwardRef as ReactComponent };